import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const PackagingDetailConfigurationSkeleton = () => {
  return (
    <Styles.MainContainer>
      <Styles.SectionContainer>
        <Skeleton variant="text" width={120} height={24} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.SectionContainer>

      <Styles.SectionContainer>
        <Skeleton variant="text" width={100} height={24} />
        <Styles.DimensionsContainer>
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
        </Styles.DimensionsContainer>
      </Styles.SectionContainer>

      <Styles.SectionContainer>
        <Skeleton variant="text" width={60} height={24} />
        <Styles.DimensionsContainer>
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
        </Styles.DimensionsContainer>
      </Styles.SectionContainer>
    </Styles.MainContainer>
  )
}

export default PackagingDetailConfigurationSkeleton
